jQuery(document).ready(function ($) {
    $('.header__nav--item.toggle').on('mouseenter', function (event) {
        $(this).addClass('expanded');
        $(this).find('ul').stop(true, true).fadeIn(500);
    });

    $('.header__nav--subnav').on('mouseover', function (event) {
        $(this).parent().addClass('expanded');
        $(this).stop(true, true).show();
    });

    $('.header__nav--item.toggle').on('mouseout', function (event) {
        $(this).removeClass('expanded');
        $(this).find('ul').stop(true, true).fadeOut(500);
    });

    $('.header__mobile--toggle').on('click', function (event) {
        $(this).toggleClass('open');
        $(this).next().stop(true, true).slideToggle(500);
    });

    $('.header__dropdown--item.toggle').on('click', function (event) {
        event.preventDefault();

        $(this).toggleClass('expanded');
        $(this).next().stop(true, true).slideToggle(500);
    });

    let upper_deck_timeout = 1;

    $.fn.showUpperDeck = function (speed = 1000) {
        const main_logo = this.find('#main-logo');
        const upper_deck = this.find('#upper-deck-logo');

        const transition = `all ${speed}ms ease`;

        main_logo.css('transition', transition);
        upper_deck.css('transition', transition);

        main_logo.css('opacity', 0);

        upper_deck_timeout = setTimeout(function () {
            upper_deck.css('opacity', 1);
        }.bind(upper_deck), speed);

        return this;
    }

    $.fn.hideUpperDeck = function (speed = 1000) {
        const main_logo = this.find('#main-logo');
        const upper_deck = this.find('#upper-deck-logo');

        const transition = `all ${speed}ms ease`;

        main_logo.css('transition', transition);
        upper_deck.css('transition', transition);

        upper_deck.css('opacity', 0);

        upper_deck_timeout = setTimeout(function () {
            main_logo.css('opacity', 1);
        }.bind(main_logo), speed);

        return this;
    }

    $.fn.toggleUpperDeck = function (speed = 1000) {
        const main_logo = this.find('#main-logo');
        const upper_deck = this.find('#upper-deck-logo');

        const transition = `all ${speed}ms ease`;

        main_logo.css('transition', transition);
        upper_deck.css('transition', transition);

        if (parseInt(main_logo.css('opacity')) === 0) {
            upper_deck.css('opacity', 0);

            upper_deck_timeout = setTimeout(function () {
                main_logo.css('opacity', 1);
            }.bind(main_logo), speed);

            return this;
        }

        main_logo.css('opacity', 0);

        upper_deck_timeout = setTimeout(function () {
            upper_deck.css('opacity', 1);
        }.bind(upper_deck), speed);

        return this;
    }

    if ($('#upper-deck-logo').length > 0) {
        $('.header__logo').on('mouseenter', function (event) {
            clearTimeout(upper_deck_timeout);
            $(this).stop(true, true).hideUpperDeck(500);
        });

        $('.header__logo').on('mouseleave', function (event) {
            clearTimeout(upper_deck_timeout);
            $(this).stop(true, true).showUpperDeck(500);
        });

        setTimeout(function () {
            $('.header__logo').toggleUpperDeck();
        }, 1000);
    }
});